var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoginMobileIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 25 25",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.7 12.0008c0-5.68897 4.61183-10.3008 10.3008-10.3008 5.689 0 10.3008 4.61183 10.3008 10.3008 0 2.2895-.7469 4.4046-2.0104 6.1148-1.7161-2.7736-4.7868-4.6234-8.2907-4.6234-3.50378 0-6.57424 1.8496-8.2904 4.6229-1.26329-1.7101-2.0101-3.825-2.0101-6.1143zm10.3008-12.0008c-6.62785 0-12.0008 5.37295-12.0008 12.0008 0 6.6279 5.37295 12.0008 12.0008 12.0008 6.6279 0 12.0008-5.3729 12.0008-12.0008 0-6.62785-5.3729-12.0008-12.0008-12.0008zm3.1269 8.65608c0 1.72652-1.3996 3.12602-3.1261 3.12602s-3.12608-1.3995-3.12608-3.12602c0-1.72648 1.39958-3.12606 3.12608-3.12606s3.1261 1.39958 3.1261 3.12606z",
    fill: "#3856a7",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoginMobileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login-mobile-icon.b794854ef040e7f6b5d89b0b66be9537.svg";